// src/components/legal/useLegalPendiente.js
//
// ACEPTAR LOS TÉRMINOS Y EL AVISO DE PRIVACIDAD (LEGAL.md, L4) — los datos.
//
// Dos usos:
//   · `useLegalPendiente()` — dentro de la app: qué le falta aceptar a esta
//     cuenta. Si la pregunta falla, se contesta que no falta nada: un documento
//     que no carga no puede convertirse en una tarjeta que estorba para siempre.
//   · `versionesLegales()` — en el registro: las versiones vigentes que la
//     casilla dice aceptar. Se mandan al crear la cuenta, y el servidor las
//     compara con las suyas.

import { useCallback, useEffect, useState } from 'react';

const NADA = { cargando: false, pendiente: false, documentos: [] };

function token() {
  try { return localStorage.getItem('token'); } catch { return null; }
}

export function useLegalPendiente() {
  const [estado, setEstado] = useState(() => (token() ? { ...NADA, cargando: true } : NADA));

  const carga = useCallback(async () => {
    const t = token();
    if (!t) return;
    try {
      const r = await fetch('/api/legal/pendientes', { headers: { Authorization: `Bearer ${t}` } });
      if (!r.ok) { setEstado(NADA); return; }
      const d = await r.json();
      setEstado({
        cargando: false,
        pendiente: d.pendiente === true && (d.documentos || []).length > 0,
        documentos: d.documentos || [],
      });
    } catch {
      setEstado(NADA);
    }
  }, []);

  useEffect(() => { carga(); }, [carga]);

  const listo = useCallback(() => setEstado((e) => ({ ...e, pendiente: false })), []);

  return { ...estado, recarga: carga, listo };
}

/** Las versiones vigentes de los dos documentos públicos. `{}` si no cargan. */
export async function versionesLegales() {
  try {
    const [t, p, e] = await Promise.all([
      fetch('/api/vitrina/legal/terminos').then((r) => (r.ok ? r.json() : null)),
      fetch('/api/vitrina/legal/privacidad').then((r) => (r.ok ? r.json() : null)),
      fetch('/api/vitrina/legal/edad').then((r) => (r.ok ? r.json() : null)),
    ]);
    if (!t?.version || !p?.version) return {};
    // La de edad va aparte y SIN bloquear al resto: si un backend antiguo no la
    // sirve todavía, el registro tiene que seguir funcionando con las otras dos.
    // Quien se registre en ese rato se queda sin la firma de edad, y la app se
    // la pide al entrar, que es justo para lo que está la pantalla de
    // pendientes.
    return {
      terminos: t.version,
      privacidad: p.version,
      ...(e?.version ? { edad: e.version } : {}),
    };
  } catch {
    return {};
  }
}

/** Acepta las versiones indicadas. Devuelve `{ ok, status }`. */
export async function aceptaLegal(versiones) {
  try {
    const r = await fetch('/api/legal/aceptar', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(versiones),
    });
    return { ok: r.ok, status: r.status };
  } catch {
    return { ok: false, status: 0 };
  }
}
